export default {
    fontWeight500: "500",
    fontWeight600: "600",
    fontWeightBold: "bold"
}